import { Component } from 'react'

import classNames from 'classnames'
import PropTypes from 'prop-types'
import { List } from 'semantic-ui-react'

import { formatDropdownOptions } from 'utils/formatters'

import Dropdown from 'components/Core/Dropdown/Dropdown'
import Modal from 'components/Core/Modal'

import styles from './MarkAsExportedModal.component.module.css'
import messages from './MarkAsExportedModal.messages'

export default class MarkAsExportedModal extends Component {
  state = {
    orderExportIntegrationId: null,
  }

  onSave = () => {
    const {
      setPageLoaderActive,
      renderActionsToasterMessage,
      handleMarkAsExported,
      selectedOrdersIds,
      handleResetOrder,
    } = this.props

    const { orderExportIntegrationId } = this.state

    setPageLoaderActive(true)

    handleMarkAsExported(selectedOrdersIds, orderExportIntegrationId)
      .then(({ data }) => {
        const mutationNameKey = Object.keys(data)[0]
        const returnedOrders = data[mutationNameKey]
        const updatedOrdersCount = returnedOrders?.updatedOrderIds?.length || 0

        handleResetOrder()
        setPageLoaderActive(false)

        renderActionsToasterMessage(
          updatedOrdersCount,
          selectedOrdersIds.length - updatedOrdersCount,
        )
      })
      .catch((error) => {
        console.error(error)
        setPageLoaderActive(false)
      })
  }

  getDropdownOptions = () =>
    formatDropdownOptions(this.props.orderExportIntegrations)

  setOrderExport = (e, { value }) => {
    this.setState({
      orderExportIntegrationId: value,
    })
  }

  render() {
    return (
      <Modal
        open
        onClose={this.props.onClose}
        primaryActionOnClick={this.onSave}
        primaryActionLabel={messages.markAsExported}
        title={messages.markAsExported}
        primaryDisabled={!this.state.orderExportIntegrationId}
      >
        <List>
          <List.Item>
            <span className={classNames(styles.label)}>
              {messages.selectIntegrationType}
            </span>
            <Dropdown
              className={styles.dropdown}
              placeholder={messages.selectOne}
              options={this.getDropdownOptions()}
              onChange={this.setOrderExport}
            />
          </List.Item>
        </List>
      </Modal>
    )
  }
}

MarkAsExportedModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  orderExportIntegrations: PropTypes.arrayOf(PropTypes.object).isRequired,
  setPageLoaderActive: PropTypes.func.isRequired,
  handleResetOrder: PropTypes.func.isRequired,
  renderActionsToasterMessage: PropTypes.func.isRequired,
  handleMarkAsExported: PropTypes.func.isRequired,
  selectedOrdersIds: PropTypes.arrayOf(PropTypes.string).isRequired,
}
